import React, { useState } from "react";

import {
  Container,
  Box,
  IconButton,
  Stack,
  Drawer,
  Hidden,
  Typography,
  styled,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink } from "react-router-dom";
import logo from "../Components/images/mainlogo.png";

const StyledLink = styled(NavLink)(() => ({
  textDecoration: "none",
  "&:focus, &:hover, &:visited, &:link, &:active": {
    textDecoration: "none",
    color: "black",
  },
}));

const Header = () => {
  const [state, setState] = useState(false);

  const toggleDrawer = () => {
    setState((prev) => (prev === true ? false : true));
  };

  const data = [
    {
      title: "Defi Sage",
      path: "/",
    },
    {
      title: "Home",
      path: "/",
    },

    {
      title: "White paper",
      path: "/whitepaper",
    },

    {
      title: "Dapp",
      path: "/staking",
    },
    {
      title: "Farming",
      path: "/farming",
    },
  ];

  return (
    <Box
      sx={{
        display: { md: "none", xs: "block" },
        background:
          " linear-gradient(98.3deg, rgb(0, 0, 0) 10.6%, rgb(255, 0, 0) 97.7%)",
        boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
        py: { md: 2, xs: 1 },
      }}
    >
      <Container>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Box>
            <StyledLink to="/">
              <Box
                component="img"
                src={logo}
                alt="img"
                width={{ md: "60%", xs: "60px" }}
              />
            </StyledLink>
          </Box>

          <Hidden mdUp>
            <Box display="flex" alignItems="left" gap={2}>
              <IconButton onClick={() => toggleDrawer()}>
                <MenuIcon
                  style={{
                    fontSize: "28px",
                  }}
                />
              </IconButton>
            </Box>
            <Drawer anchor="left" open={state} onClose={() => toggleDrawer()}>
              <Box
                sx={{
                  background:
                    " linear-gradient(98.3deg, rgb(0, 0, 0) 10.6%, rgb(255, 0, 0) 97.7%)",
                  width: 250,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 3,
                  px: 1,
                  pt: 1,
                }}
              >
                <Box>
                  <NavLink to="/">
                    <Box
                      component="img"
                      src={logo}
                      alt="img"
                      sx={{ width: "70px" }}
                    />
                  </NavLink>
                </Box>

                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  gap={1}
                  mt={-2}
                  pl={2}
                >
                  {data.map((item, i) => {
                    return (
                      <NavLink
                        to={item?.path}
                        style={{ textDecoration: "none", color: "white" }}
                        key={i}
                      >
                        <Typography
                          key={i}
                          className="rainfall-button"
                          sx={{
                            cursor: "pointer",
                            mt: 2,
                            textAlign: "left",
                            fontFamily: "Roboto Slab                ",
                            fontSize: "25px",
                            transition: "1s ease-in-out",
                            color: `#fff`,
                            "&:hover": {
                              transition: "1s ease-in-out",
                              color: `#E0115F`,
                            },
                          }}
                        >
                          {item?.title}
                        </Typography>
                      </NavLink>
                    );
                  })}
                </Box>
              </Box>
            </Drawer>
          </Hidden>
        </Stack>
      </Container>
    </Box>
  );
};

export default Header;
